(function(){
  'use strict';
  function count(){document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent='('+(window.FREYA_SHOP?.cartCount||0)+')');}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',count);else count();
  const host=document.getElementById('native-product-gallery');
  const product=window.FREYA_PRODUCTS?.find(p=>p.handle===window.FREYA_SHOP?.productHandle);
  if(host&&product&&window.FREYA_PRODUCT_GALLERY){host.innerHTML=window.FREYA_PRODUCT_GALLERY(product);window.FREYA_INIT_GALLERY(host);}
  const variant=document.getElementById('native-variant'),add=document.getElementById('native-add');
  const picker=document.querySelector('[data-mini-sauce-picker]');
  function checkSauces(){
    if(!picker)return true;
    const choices=Array.from(picker.querySelectorAll('input[type="checkbox"]'));
    const required=Number(picker.dataset.requiredCount),total=choices.filter(input=>input.checked).length;
    const valid=total===required;
    choices.forEach(input=>{input.disabled=valid&&!input.checked;input.setCustomValidity('');});
    if(!valid)choices[0].setCustomValidity(picker.dataset.error);
    picker.querySelector('[role="status"]').textContent=total+' / '+required+' '+picker.dataset.countLabel;
    if(add)add.disabled=variant.selectedOptions[0].dataset.available!=='true'||!valid;
    return valid;
  }
  if(picker){picker.addEventListener('change',checkSauces);checkSauces();}
  if(variant&&add){variant.addEventListener('change',()=>{
    const option=variant.selectedOptions[0];document.getElementById('native-price').textContent=option.dataset.price;
    add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?'Tükendi':'Sepete ekle';
    checkSauces();
    const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);
  });}
  // Native form submission keeps Shopify's inventory checks and cart redirects.
  document.addEventListener('submit',e=>{
    const form=e.target.closest('.freya-buy-form');if(!form)return;
    if(form.contains(picker)&&!checkSauces()){e.preventDefault();form.reportValidity();return;}
    if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}
    form.setAttribute('aria-busy','true');const button=form.querySelector('button[type="submit"]');
    if(button){button.disabled=true;button.textContent='Sepete ekleniyor…';}
  });
  window.addEventListener('pageshow',()=>document.querySelectorAll('.freya-buy-form[aria-busy]').forEach(form=>{
    form.removeAttribute('aria-busy');const button=form.querySelector('button[type="submit"]');if(button){button.disabled=false;button.textContent='Sepete ekle';}variant?.dispatchEvent(new Event('change'));
  }));
  const contact=document.getElementById('contactForm');
  if(contact)contact.addEventListener('submit',e=>{
    e.preventDefault();if(!contact.reportValidity())return;const data=new FormData(contact);
    const message=['Merhaba Freya Gurme!','İsim: '+data.get('name'),data.get('phone')?'Telefon: '+data.get('phone'):'','Konu: '+data.get('subject'),data.get('message')].filter(Boolean).join('\n');
    window.open('https://wa.me/905322523555?text='+encodeURIComponent(message),'_blank','noopener');
  });
})();
